
<mat-dialog-content>
  <div class="modal-header">
    <h4 class="modal-title pull-left">SBAR</h4><i class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body">
    <SBAR createSBARWithoutSupportTicket="createSBARWithoutSupportTicket" (saveSBAR)="saveSBAR($event)"></SBAR>
  </div>
</mat-dialog-content>